/* @flow weak */
import React from 'react';
import CurrentUser from 'auth/CurrentUser';
import enumerate from 'lib/enumerate';
import PromptStore from 'stores/PromptStore';
import RequireUser from 'components/mixins/RequireUser';
import PromptActions from 'actions/PromptActions';
import { PromptNames } from 'constants/PromptConstants';
import LinkSmsDevicePage from 'user/components/LinkSmsDevicePage.jsx';
import ShouldLinkSmsDeviceView from 'setup/components/ShouldLinkSmsDeviceView.jsx';

const STATUS = enumerate([
  'question',
  'device_verify',
]);

const SetupSignature = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    RequireUser,
  ],

  getInitialState() {
    const forcePhone = CurrentUser.inExpVariant('FORCE_PHONE') || CurrentUser.inExpVariant('FORCE_PHONE', 'allow_skip');
    return {
      status: forcePhone ? STATUS.device_verify : STATUS.question,
    };
  },

  componentDidMount() {
    if (!PromptStore.hasDismissed(PromptNames.NUX_SETUP_SMS_DEVICE)) {
      PromptActions.recordDismissal(PromptNames.NUX_SETUP_SMS_DEVICE);
    }
  },

  onDone() {
    this.context.router.push('/');
  },

  onSelect(response) {
    if (response === false) {
      this.context.router.push('/');
    } else {
      this.setState({ status: STATUS.device_verify });
    }
  },

  renderDeviceVerification() {
    return (
      <LinkSmsDevicePage
        onDone={this.onDone}
        onSkip={CurrentUser.inExpVariant('FORCE_PHONE') ? undefined : this.onDone}
      />
    );
  },

  renderQuestion() {
    return <ShouldLinkSmsDeviceView onSelect={this.onSelect} />;
  },

  render() {
    return {
      [STATUS.question]: this.renderQuestion,
      [STATUS.device_verify]: this.renderDeviceVerification,
    }[this.state.status]();
  },
});

export default SetupSignature;



// WEBPACK FOOTER //
// ./src/setup/components/SetupSmsDevice.jsx